const stringEnv = (state = "") => {
  return state;
};

export default stringEnv;
